import { t } from "@lingui/macro";
import * as React from "react";
import { G, Path, Svg, Defs, ClipPath } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const CalendarCheckIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 16" title={t`Calendar Check`} {...props}>
    <Svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <G clipPath="url(#a)">
        <Path
          fill="currentColor"
          d="M11 .25a.75.75 0 0 1 .75.75v.25h1.694c1.22 0 2.306.931 2.306 2.194V7a.75.75 0 0 1-.75.75H1.75v5.806c0 .332.308.694.806.694H7a.75.75 0 0 1 0 1.5H2.556c-1.22 0-2.306-.931-2.306-2.194V3.444c0-1.263 1.086-2.194 2.306-2.194H4.25V1a.75.75 0 0 1 1.5 0v.25h4.5V1A.75.75 0 0 1 11 .25Zm3.44 9.252a.75.75 0 0 1 1.12.996l-4 4.5a.75.75 0 0 1-1.09.032l-1.5-1.5a.75.75 0 1 1 1.06-1.06l.938.938 3.472-3.906ZM2.556 2.75c-.498 0-.806.362-.806.694V6.25h12.5V3.444c0-.332-.307-.694-.806-.694H11.75V4a.75.75 0 0 1-1.5 0V2.75h-4.5V4a.75.75 0 0 1-1.5 0V2.75H2.556Z"
        />
      </G>
      <Defs>
        <ClipPath id="a">
          <Path fill="#fff" d="M0 0h16v16H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  </Icon>
);
